import { JSX } from "react";

export const SvgKleinerDan = (): JSX.Element => {
    return (
        <svg
            className="small-damage"
            width="39px"
            height="28px"
            viewBox="0 0 39 28"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <polygon
                    id="path-h-aikoedps-1"
                    points="0 0 27.1631472 0 27.1631472 27.163063 0 27.163063"
                ></polygon>
                <polygon
                    id="path-h-aikoedps-3"
                    points="0 0 27.1631472 0 27.1631472 27.163063 0 27.163063"
                ></polygon>
            </defs>
            <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="211118-ABS-platform-[ruitschade-2]"
                    transform="translate(-450.000000, -1079.000000)"
                >
                    <g
                        id="kleiner-dan"
                        transform="translate(450.000000, 1079.000000)"
                    >
                        <polygon
                            id="Fill-1"
                            fill="#E67A01"
                            className="fill-secondary"
                            fillRule="nonzero"
                            points="2.23014548 21.8401026 4.10000344 21.8401026 4.10000344 5.32300527 2.23014548 5.32300527"
                        ></polygon>
                        <polygon
                            id="Fill-2"
                            fill="#E67A01"
                            className="fill-secondary"
                            fillRule="nonzero"
                            points="0.00140320733 7.18085178 6.32868958 7.18085178 6.32868958 5.32300527 0.00140320733 5.32300527"
                        ></polygon>
                        <polygon
                            id="Fill-3"
                            fill="#E67A01"
                            className="fill-secondary"
                            fillRule="nonzero"
                            points="0 14.5103088 6.32868958 14.5103088 6.32868958 12.652743 0 12.652743"
                        ></polygon>
                        <polygon
                            id="Fill-4"
                            fill="#E67A01"
                            className="fill-secondary"
                            fillRule="nonzero"
                            points="0.00140320733 21.8401026 6.32868958 21.8401026 6.32868958 19.9825368 0.00140320733 19.9825368"
                        ></polygon>
                        <g
                            id="Fill-5-Clipped"
                            transform="translate(10.145835, 0.000000)"
                        >
                            <mask id="mask-h-aikoedps-2" fill="white">
                                <use href="#path-h-aikoedps-1"></use>
                            </mask>
                            <g id="path-1"></g>
                            <path
                                d="M13.5815876,0 C6.0807148,0 0,6.08065865 0,13.5815315 C0,21.0824044 6.0807148,27.163063 13.5815876,27.163063 C21.0824605,27.163063 27.1631752,21.0824044 27.1631752,13.5815315 C27.1631752,6.08065865 21.0824605,0 13.5815876,0 M13.5815876,2.75028637 C16.4747205,2.75028637 19.1946976,3.8769496 21.2404055,5.92271363 C23.2861695,7.96842153 24.4128889,10.6883986 24.4128889,13.5815315 C24.4128889,16.4746644 23.2861695,19.1946415 21.2404055,21.2404055 C19.1946976,23.2861695 16.4747205,24.4127766 13.5815876,24.4127766 C10.6884547,24.4127766 7.9684776,23.2861695 5.9227697,21.2404055 C3.8770057,19.1946415 2.7502863,16.4746644 2.7502863,13.5815315 C2.7502863,10.6883986 3.8770057,7.96842153 5.9227697,5.92271363 C7.9684776,3.8769496 10.6884547,2.75028637 13.5815876,2.75028637"
                                id="Fill-5"
                                fill="#E67A01"
                                className="fill-primary"
                                fillRule="nonzero"
                                mask="url(#mask-h-aikoedps-2)"
                            ></path>
                        </g>
                        <g
                            id="Fill-8-Clipped"
                            transform="translate(10.145835, 0.000000)"
                        >
                            <mask id="mask-h-aikoedps-4" fill="white">
                                <use href="#path-h-aikoedps-3"></use>
                            </mask>
                            <g id="path-3"></g>
                            <path
                                d="M15.8937028,16.2208017 C15.4084737,16.7407181 14.8539823,17.052623 14.1261668,17.052623 C13.1671587,17.052623 12.4770052,16.4993664 12.1292905,15.458355 L15.4778483,15.458355 L15.4778483,14.0026116 L11.8821015,14.0026116 C11.8764325,13.8789609 11.8732332,13.752111 11.8732332,13.6213882 C11.8732332,13.4908899 11.8760957,13.3639277 11.8814841,13.2401648 L16.1709766,13.2401648 L16.1709766,11.7844775 L12.1156513,11.7844775 C12.4368174,10.7793321 13.075389,10.2248407 14.0221049,10.2248407 C14.7152893,10.2248407 15.2352618,10.5021144 15.755066,10.8833378 L17.3840774,9.28901363 C16.4828815,8.38793001 15.3045241,7.93733207 14.1261668,7.93733207 C11.6572515,7.93733207 9.7563546,9.32280286 9.1215436,11.7992393 L7.9915127,11.8884271 L7.9915127,13.2401648 L8.9058987,13.2401648 C8.8971988,13.3987834 8.8926524,13.5604329 8.8926524,13.7253939 C8.8926524,13.8301293 8.8946169,13.933237 8.8979846,14.0350537 L7.9915127,14.1066173 L7.9915127,15.458355 L9.0730488,15.458355 C9.651507,18.036103 11.5628999,19.3401316 13.9528426,19.3401316 C15.3391553,19.3401316 16.5522561,18.7855841 17.5226582,17.7458074 L15.8937028,16.2208017 Z"
                                id="Fill-8"
                                fill="#E67A01"
                                className="fill-primary"
                                fillRule="nonzero"
                                mask="url(#mask-h-aikoedps-4)"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
